import axios from 'axios';
import { getToken } from '../utils/auth'
import qs from 'qs';
// 创建axios实例
const url = window.location.href.indexOf('test.') > -1 ? 'https://test.zyrljt.com/' : window.location.href.indexOf('www.') > -1 ? 'https://www.zyrljt.com/' : ''
const service = axios.create({
  baseURL: url,
  timeout: 30000 // 请求超时时间
});
// 添加request拦截器
service.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  if (getToken()) {
    config.headers['Authorization'] = 'Basic c2FiZXI6c2FiZXJfc2VjcmV0'
    config.headers['Blade-Auth'] = 'bearer ' + getToken()
  }
  return config
}, error => {
  Promise.reject(error)
});
// 添加respone拦截器
service.interceptors.response.use(
  response => {
    let res={};
    res.status=response.status
    res.data=response.data;
    return res;
  },
  error => {
    if(error.response && error.response.status == 404){
      // router.push('/blank.vue')
    }
    return Promise.reject(error.response)
  }
);

export function get(url) {
  // params.t = new Date().getTime(); //get方法加一个时间参数,解决ie下可能缓存问题.
  return service({
    url: url,
    method: 'get',
    headers: {
    },
    // params
  })
}
export function post(url, data) {
  // params.t = new Date().getTime(); //get方法加一个时间参数,解决ie下可能缓存问题.
  return service({
    url: url,
    method: 'post',
    headers: {
    },
    data
  })
}
//不要忘记export
export {
  service
}



// WEBPACK FOOTER //
// ./src/utils/http.js